module.exports = __webpack_public_path__ + "static/feature2-70747024d719e4585c42e4cc7b95a162.png";